<footer class="footer secondary-bg text-color">
  <div class="container-footer">
    <p>Demo for <span class="data-client">{{isAuthenticated() ? userData?.clientName :
        clientsFromUserScreen?.name}}</span><span class="data-client">{{isAuthenticated() ? currentProject : ''}}</span>
    </p>
    <p class="text-color">
      &copy; {{ currentYear }} Kosten Digital | <a href="#">Privacy Policy</a> |
      <a href="#">Terms</a>
    </p>
  </div>
</footer>
